// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Xv0HL","btn-google":"Button_btn-google__K4smK","icon":"Button_icon__8q5jY"};